<div class="details-dialog">
  <div class="dialog-header">
    <h2>File Details</h2>
    <button mat-icon-button (click)="closeDialog()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="file-info-section">
      <h3>File Information</h3>
      <div class="info-grid">
        <div class="info-row">
          <span class="info-label">File Name:</span>
          <span class="info-value">{{ file.FileName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Status:</span>
          <span class="info-value">
            <span class="badge badge-completed">COMPLETED</span>
          </span>
        </div>
        <div class="info-row">
          <span class="info-label">Started:</span>
          <span class="info-value">{{ file.StartedAt | date:'medium' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Completed:</span>
          <span class="info-value">{{ file.CompletedAt || file.StartedAt | date:'medium' }}</span>
        </div>
      </div>
    </div>

    <!-- Processing Details -->
    <div class="processing-details-section">
      <h3>Processing Details</h3>

      <!-- Items Grid -->
      <div class="contents-grid">
        @for (item of file.ProcessingItems; track item) {
          <div class="content-item">
            <div class="item-icon">
              <img [ngClass]="'status-' + item.Status.toLowerCase()" [src]="getIconImage(item.Name)" [alt]="item.Name" />
            </div>
            <div class="item-details">
              <h4>{{ item.Name }}</h4>
              <span class="item-count">{{ item.Processed || '0' }}</span>
              <div class="item-status" [ngClass]="'status-' + item.Status.toLowerCase()">
                <span class="status-indicator"></span>
                {{ item.Status }}
              </div>
              <p class="item-processed">
                {{ item.Processed || '0' }} / {{ getTotalItemCount(item) }} Records
                processed
              </p>
              @if (item.Failed) {
                <p class="item-processed item-failed">
                  <i class="fa-solid fa-circle-xmark"></i>
                  {{ item.Failed}} Records
                  Failed
                </p>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </div>
</div>
